/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 事故種別
 */
export type TrafficAccidentAccidentTypeEnum =
  (typeof TrafficAccidentAccidentTypeEnum)[keyof typeof TrafficAccidentAccidentTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrafficAccidentAccidentTypeEnum = {
  HEAD_ON_COLLISION: 'HEAD_ON_COLLISION',
  SIDE_COLLISION: 'SIDE_COLLISION',
  REAR_END_COLLISION: 'REAR_END_COLLISION',
  SINGLE_VEHICLE: 'SINGLE_VEHICLE',
} as const;
